import styled from "styled-components";
import { ShareLogo, ShareErrorIMG } from "@assets";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  background: #49028e;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px 16px 100px;
`;

export const RecaptchaContainer = styled.div`
  display: flex;
  justify-content: center !important;
  align-items: center;
  width: calc(100vw - 32px);
  height: calc(100vh - 60px);

  &>div{
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
`

export const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  svg {
    cursor: pointer;
  }
`;

export const Name = styled.div`
  color: #e8e03c;
  font-size: 32px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 8px;
`;

export const Welcome = styled.div`
  color: #ffffff;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding: 4px 4px 0px 4px;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
`;

export const Logo = styled.img.attrs({
  alt: "img",
  src: ShareLogo,
})`
  width: 193px;
  object-fit: contain;
  position: absolute;
  top: -50px;
`;

export const DescriptionContainer = styled.div`
  background: #ffffff33;
  border-radius: 20px;
  padding: 16px;
  width: 306px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Description = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin-top: 100px;
  width: 75%;

  span {
    color: #e8e03c;
  }

  @media screen and (max-width: 375px) {
    width: 90%;
  }
`;

export const Button = styled(AntButton)`
  width: 192px !important;
  height: 48px !important;
  border-radius: 16px !important;
  margin-top: 30px;
  color: #ffffff !important;
  background: linear-gradient(180deg, #2d0059 0%, #4d0395 100%);
  border: none !important;
  border-radius: 16px !important;

  :hover {
    background: linear-gradient(180deg, #2d0059 0%, #4d0395 100%);
    border: none !important;
    color: #ffffff !important;
  }
`;

export const FollowTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  text-align: center;
  margin-top: 32px;
`;

export const FollowWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  gap: 8px;

  #app {
    width: 100%;
    height: 48px;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-bottom: 1px solid #6d35a5;
  width: 100%;
`;

export const ErrorImage = styled.img.attrs({
  alt: "img",
  src: ShareErrorIMG,
})`
  width: 300px;
  object-fit: contain;
  margin-top: 24px;
`;

export const ErrorTitle = styled.div`
  color: #e8e03c;
  font-weight: 800;
  font-size: 20px;
  margin-top: 16px;
`;

export const ErrorDescription = styled.div`
  color: #fff;
  width: 191px;
  font-size: 13px;
  font-weight: 400;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 23px;
  line-height: 30px;
`;

export const UserName = styled.div`
font-size: 15px;
font-weight: 600;
line-height: normal;
color: #E8E03C;
`;

export const TypeInfo = styled.div`
padding-bottom: 15px;
font-size: 12px;
font-weight: 500;
line-height: normal;
color: #fff;
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh);
	display: flex;
	align-items: center;
	justify-content: center;

  .ant-spin-dot i {
    background-color: #fff !important;
  }
`;